"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeNeoTaxFeeDetails = void 0;
// Stripe has a minimum fee per iteration of $0.50 (https://stripe.com/docs/api/charges/object)
// Important: This only applies to the pre-discount amount.  You can discount down to zero and
// Stripe will still create the invoice and everything works.  We apply the minimum to avoid
// errors being thrown when we create the subscription in Stripe.
const STRIPE_MINIMUM_FEE_PER_ITERATION = 50;
const getIntendedTotalDiscountCents = (totalFeeCentsNoDiscount, amountOffCents, percentOff) => {
    if (amountOffCents && amountOffCents > 0) {
        return amountOffCents;
    }
    else if (percentOff && percentOff > 0) {
        // when applying the percentOff is a number between 1 and 100
        return Math.round(totalFeeCentsNoDiscount * percentOff * 0.01);
    }
    return 0;
};
const computeNeoTaxFeeDetails = ({ amountOffCents, creditAmountCents, feePercent, flatFeeCents, numberOfIterations, percentOff, }) => {
    const minimumTotalFeeCents = STRIPE_MINIMUM_FEE_PER_ITERATION * numberOfIterations;
    const totalFeeBeforeDiscountCents = Math.max(minimumTotalFeeCents, typeof flatFeeCents === 'number' ? flatFeeCents : Math.round(creditAmountCents * feePercent));
    // Discount before considering minimums
    const intendedTotalDiscountCents = getIntendedTotalDiscountCents(totalFeeBeforeDiscountCents, amountOffCents, percentOff);
    const totalFeeAfterDiscountCents = Math.max(0, totalFeeBeforeDiscountCents - intendedTotalDiscountCents);
    const totalDiscountCents = totalFeeBeforeDiscountCents - totalFeeAfterDiscountCents;
    const iterationFeeBeforeDiscountCents = Math.max(STRIPE_MINIMUM_FEE_PER_ITERATION, 
    // We use Math.floor, so that we don't overcharge the customer.
    // The sum of the iterations should not exceed the total fee.
    Math.floor(totalFeeBeforeDiscountCents / numberOfIterations));
    const iterationFeeAfterDiscountCents = Math.floor(totalFeeAfterDiscountCents / numberOfIterations);
    const iterationDiscountCents = iterationFeeBeforeDiscountCents - iterationFeeAfterDiscountCents;
    return {
        iterationFeeBeforeDiscountCents,
        iterationFeeAfterDiscountCents,
        iterationDiscountCents,
        totalFeeBeforeDiscountCents,
        totalFeeAfterDiscountCents,
        totalDiscountCents,
    };
};
exports.computeNeoTaxFeeDetails = computeNeoTaxFeeDetails;
